import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IDatePicker } from '@bridebook/models/source/models/Weddings.types';

interface ExactDate {
  d: number;
  m: number;
  y: number;
}

export const isDateExact = (
  date: IDatePicker | PartialRecursive<IDatePicker> | null | undefined,
): date is ExactDate => {
  if (!date) return false;
  return typeof date.d === 'number' && typeof date.m === 'number' && typeof date.y === 'number';
};
